var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportsActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 16,
    fill: "url(#paint0_linear_15263_36599)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6428 12.8047C18.7462 12.8047 16.4585 13.3779 14.9201 14.9162C13.3818 16.4546 12.8086 18.7423 12.8086 21.6389V28.3539C12.8086 31.2505 13.3818 33.5382 14.9201 35.0766C16.4585 36.6149 18.7462 37.1881 21.6428 37.1881H28.3578C31.2544 37.1881 33.5421 36.6149 35.0805 35.0766C36.6188 33.5382 37.192 31.2505 37.192 28.3539V21.6389C37.192 18.7423 36.6188 16.4546 35.0805 14.9162C33.5421 13.3779 31.2544 12.8047 28.3578 12.8047H21.6428ZM14.8086 21.6389C14.8086 18.9396 15.3546 17.3102 16.3344 16.3304C17.3141 15.3507 18.9435 14.8047 21.6428 14.8047H28.3578C31.0571 14.8047 32.6865 15.3507 33.6663 16.3304C34.646 17.3102 35.192 18.9396 35.192 21.6389V28.3539C35.192 31.0532 34.646 32.6826 33.6663 33.6623C32.6865 34.6421 31.0571 35.1881 28.3578 35.1881H21.6428C18.9435 35.1881 17.3141 34.6421 16.3344 33.6623C15.3546 32.6826 14.8086 31.0532 14.8086 28.3539V21.6389ZM26.2765 27.5782L28.9135 24.9413V24.9961C28.9135 25.4103 29.2492 25.7461 29.6635 25.7461C30.0777 25.7461 30.4135 25.4103 30.4135 24.9961V23.1308C30.4135 22.7166 30.0777 22.3808 29.6635 22.3808H27.7982C27.384 22.3808 27.0482 22.7166 27.0482 23.1308C27.0482 23.545 27.384 23.8808 27.7982 23.8808H27.8526L25.8627 25.8707L24.878 24.3935C24.7533 24.2066 24.5515 24.0854 24.3278 24.0632C24.1042 24.0411 23.8825 24.1204 23.7236 24.2792L20.7392 27.2637C20.4463 27.5566 20.4463 28.0315 20.7392 28.3244C21.0321 28.6172 21.5069 28.6172 21.7998 28.3244L24.1374 25.9868L25.1221 27.4639C25.2468 27.6509 25.4487 27.7721 25.6723 27.7943C25.8959 27.8164 26.1176 27.7371 26.2765 27.5782Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15263_36599",
    x1: 50,
    y1: 0.00000160187,
    x2: -3.75,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E4AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443569,
    stopColor: "#10C5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9240DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsActive);
export default __webpack_public_path__ + "static/media/reports-active.36a4974edf233ebd21bafddc72c1a6c6.svg";
export { ForwardRef as ReactComponent };